<div class="container-fluid" style="max-height: 75vh; overflow-y: auto;">
<div class="row">

    <h2 class="col-sm-12 text-center" style="background-color: black; color: white; padding: 10px;">Reset My Password</h2>

    <div class="col-sm-12 text-center mb-4" style="background-color: honeydew;">
      <form (ngSubmit)="onSubmit()" #f="ngForm">

        <div class="form-group">
          <label for="password" class="form-label font-weight-bold" style="color: black;">Password</label>
          <input type="password" name="password" id="password" class="form-control"
          pattern="^(?=.*[-._!&quot;`'#%&amp;,:;&lt;&gt;=@{}~\$\(\)\*\+\/\\\?\[\]\^\|]).{6,100}$"
          [(ngModel)]="newPassword" required minlength="6" #pass="ngModel" autocomplete="off">
          <span class="text-danger" *ngIf="!pass.valid || pass.untouched">
            <span *ngIf="pass.errors?.required">
              Password is required.
            </span>
            <span *ngIf="pass.errors?.minlength || pass.hasError('pattern')">
              Password must be at least 6 characters long upper case, special char. req .
            </span>
          </span>
        </div>

        <div class="text-center" id="buttons">
          <button mat-raised-button  color="primary"  type="submit" [disabled]="!f.valid || sendFlag">
            <span>Update</span>
          </button>
        </div>
      </form>

      <button mat-raised-button  color="warn"  (click)="onNoClick()" style="margin-top: 10px;">
        <span>Cancel</span>
      </button>

    <div>
  </div>

</div>


